"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  useCertifications: () => useCertifications,
  useCompletedSteps: () => useCompletedSteps,
  useCurrentStep: () => useCurrentStep,
  useCurrentTemplate: () => useCurrentTemplate,
  useDirtyStep: () => useDirtyStep,
  useEducation: () => useEducation,
  useLoadingState: () => useLoadingState,
  usePersonalInfo: () => usePersonalInfo,
  useResumeActions: () => useResumeActions,
  useResumeId: () => useResumeId,
  useResumeProgress: () => useResumeProgress,
  useResumeStore: () => useResumeStore,
  useSkills: () => useSkills,
  useWorkJourney: () => useWorkJourney
});
module.exports = __toCommonJS(src_exports);

// src/resume.ts
var import_zustand = require("zustand");
var import_immer = require("immer");
var import_middleware = require("zustand/middleware");
var import_shallow = require("zustand/react/shallow");
var import_constants = require("@shared/constants");
var import_utils = require("@shared/utils");
var import_types = require("@shared/types");
var initialFormState = {
  resumeId: null,
  currentStep: import_types.ResumeStep.TEMPLATE_SELECTION,
  completedSteps: [],
  progress: import_constants.PROGRESS_CONFIG.MIN_VALUE,
  stateLoading: "",
  selectedTemplate: import_constants.CV_TEMPLATE_ID.DEFAULT,
  info: {
    id: "",
    name: "",
    email: "",
    phone: "",
    bio: "",
    birthday: void 0,
    title: "",
    address: "",
    previewImageBase64: import_constants.IMAGES.AVATAR_DEFAULT_PNG,
    links: [],
    avatarResume: ""
  },
  journeys: [],
  skills: [],
  education: [],
  certifications: []
};
var useResumeStore = (0, import_zustand.create)()(
  (0, import_middleware.devtools)(
    (set, get) => ({
      ...initialFormState,
      actions: {
        // Resume ID management
        setResumeId: (id) => set({ resumeId: id }),
        clearResumeId: () => set({ resumeId: null }),
        // Step Navigation
        goToStep: (step) => set({ currentStep: step }),
        markStepAsComplete: (step) => set(
          (0, import_immer.produce)((state) => {
            if (!state.completedSteps.includes(step)) {
              (0, import_utils.updateResumeProgress)(state, [...state.completedSteps, step]);
            }
          })
        ),
        // Template Selection
        selectTemplate: (templateId) => set(
          (0, import_immer.produce)((state) => {
            state.selectedTemplate = templateId;
            if (!state.completedSteps.includes(import_types.ResumeStep.TEMPLATE_SELECTION)) {
              (0, import_utils.updateResumeProgress)(state, [
                ...state.completedSteps,
                import_types.ResumeStep.TEMPLATE_SELECTION
              ]);
            }
          })
        ),
        // Personal Info
        updatePersonalInfo: (info) => set(
          (0, import_immer.produce)((state) => {
            Object.assign(state.info, {
              ...info,
              birthday: info.birthday || state.info.birthday
            });
          })
        ),
        // Work Journey
        addJourney: (journey) => set(
          (0, import_immer.produce)((state) => {
            state.journeys.push({
              id: journey.id ?? (0, import_utils.generateUniqueId)(),
              ...journey
            });
          })
        ),
        updateJourney: (journey) => set(
          (0, import_immer.produce)((state) => {
            state.journeys = journey;
          })
        ),
        removeJourney: (index) => set(
          (0, import_immer.produce)((state) => {
            if (index >= 0 && index < state.journeys.length) {
              state.journeys.splice(index, 1);
            }
          })
        ),
        // Education
        addEducation: (education) => set(
          (0, import_immer.produce)((state) => {
            state.education.push({ ...education, id: (0, import_utils.generateUniqueId)() });
          })
        ),
        updateEducation: (education) => set(
          (0, import_immer.produce)((state) => {
            state.education = education;
          })
        ),
        removeEducation: (index) => set(
          (0, import_immer.produce)((state) => {
            if (index >= 0 && index < state.education.length) {
              state.education.splice(index, 1);
            }
          })
        ),
        removeSkill: (index) => set(
          (0, import_immer.produce)((state) => {
            if (index >= 0 && index < state.skills.length) {
              state.skills.splice(index, 1);
            }
          })
        ),
        updateSkills: (skills) => set({ skills }),
        // Certifications
        updateCertification: (certifications) => set(
          (0, import_immer.produce)((state) => {
            state.certifications = certifications;
          })
        ),
        removeCertification: (index) => set(
          (0, import_immer.produce)((state) => {
            if (index >= 0 && index < state.certifications.length) {
              state.certifications.splice(index, 1);
            }
          })
        ),
        // Utility Functions
        isStepCompleted: (step) => get().completedSteps.includes(step),
        resetForm: () => set(({ selectedTemplate }) => ({
          ...initialFormState,
          selectedTemplate
        })),
        resetStep: (step) => set(
          (0, import_immer.produce)((state) => {
            (0, import_utils.updateResumeProgress)(
              state,
              state.completedSteps.filter((s) => s !== step)
            );
            if (state.currentStep === step) {
              state.currentStep = import_types.ResumeStep.TEMPLATE_SELECTION;
            }
          })
        ),
        // DirtySteps Management
        markStepAsDirty: (step) => set({ dirtySteps: step }),
        clearDirtyStep: () => set({ dirtySteps: void 0 }),
        // Find first incomplete step
        findFirstIncompleteStep: () => {
          const state = get();
          const stepOrder = Object.values(import_types.ResumeStep);
          const incompleteStep = stepOrder.find(
            (step) => !state.completedSteps.includes(step)
          );
          if (incompleteStep !== state.currentStep) {
            set({ currentStep: incompleteStep });
          }
          return incompleteStep;
        },
        clearStore: () => set(() => ({ ...initialFormState })),
        // API Integration
        initializeStore: (resumeData) => {
          if (!resumeData) return;
          set(
            (0, import_immer.produce)((state) => {
              if (resumeData.id) {
                state.resumeId = resumeData.id;
              }
              const avatar = resumeData?.info?.avatar || "";
              state.info = resumeData?.info ? {
                ...resumeData.info,
                avatar,
                birthday: resumeData.info.birthday ? (0, import_utils.convertISODateToDateFormat)(resumeData.info.birthday) : "",
                links: (0, import_utils.isArray)(resumeData.links) ? resumeData.links : []
              } : {
                ...initialFormState.info,
                links: []
              };
              state.journeys = (0, import_utils.isArray)(resumeData.journeys) ? (0, import_utils.parseJourneyDataToStore)(resumeData.journeys) : [];
              state.skills = (0, import_utils.isArray)(resumeData.skills) ? resumeData.skills : [];
              state.education = (0, import_utils.isArray)(resumeData.education) ? (0, import_utils.parseEducationDataToStore)(resumeData.education) : [];
              state.certifications = (0, import_utils.isArray)(resumeData.certs) ? (0, import_utils.parseCertificationDataToStore)(resumeData.certs) : [];
              if (resumeData.templateId) {
                state.selectedTemplate = resumeData.templateId;
              }
            })
          );
        }
      }
    }),
    // eslint-disable-next-line turbo/no-undeclared-env-vars
    { enabled: process.env.NODE_ENV === "development" }
  )
);
var useLoadingState = () => useResumeStore((0, import_shallow.useShallow)((state) => state.stateLoading));
var useResumeId = () => useResumeStore((0, import_shallow.useShallow)((state) => state.resumeId));
var useCurrentTemplate = () => useResumeStore((0, import_shallow.useShallow)((state) => state.selectedTemplate));
var useCurrentStep = () => useResumeStore((0, import_shallow.useShallow)((state) => state.currentStep));
var useCompletedSteps = () => useResumeStore((0, import_shallow.useShallow)((state) => state.completedSteps));
var useResumeProgress = () => useResumeStore((0, import_shallow.useShallow)((state) => state.progress));
var usePersonalInfo = () => useResumeStore((0, import_shallow.useShallow)((state) => state.info));
var useWorkJourney = () => useResumeStore((0, import_shallow.useShallow)((state) => state.journeys));
var useSkills = () => useResumeStore((0, import_shallow.useShallow)((state) => state.skills));
var useEducation = () => useResumeStore((0, import_shallow.useShallow)((state) => state.education));
var useCertifications = () => useResumeStore((0, import_shallow.useShallow)((state) => state.certifications));
var useDirtyStep = () => useResumeStore((0, import_shallow.useShallow)((state) => state.dirtySteps));
var useResumeActions = () => useResumeStore((state) => state.actions);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  useCertifications,
  useCompletedSteps,
  useCurrentStep,
  useCurrentTemplate,
  useDirtyStep,
  useEducation,
  useLoadingState,
  usePersonalInfo,
  useResumeActions,
  useResumeId,
  useResumeProgress,
  useResumeStore,
  useSkills,
  useWorkJourney
});
